<mat-spinner
  [mode]="mode"
  [value]="value"
  [diameter]="24">
</mat-spinner>
<span>
  <ng-content></ng-content>
</span>
